export default __webpack_public_path__ + "static/media/outlet-mall.4ac70a6f.jpg";